export const catEditorEn = {
  'cat.dup.back': 'Go back',
  'cat.dup.createAnyway': 'Create anyway',
  'cat.dup.description': 'Records that look like this one already exist. Check them before adding another.',
  'cat.dup.title': 'Possible duplicates',
  'cat.dup.isbn': 'Same ISBN',
  'cat.dup.issn': 'Same ISSN',
  'cat.dup.titleAuthor': 'Similar title and author',
  'cat.edit.addAuthor': 'Add author',
  'cat.edit.addCopies': 'Add copies',
  'cat.edit.addGenre': 'Add genre',
  'cat.edit.addIsbn': 'Add ISBN',
  'cat.edit.addIssn': 'Add ISSN',
  'cat.edit.addSubject': 'Add subject',
  'cat.edit.audience': 'Audience',
  'cat.edit.authorHint': 'Surname, forename. Suggestions come from authority records.',
  'cat.edit.copies': 'Copies',
  'cat.edit.copiesCount': 'Number of copies',
  'cat.edit.copiesHint': 'Add the physical copies now so the title is borrowable as soon as it is saved.',
  'cat.edit.copyGroup': 'Copies group {n}',
  'cat.edit.coverHint': 'Optional link to a cover image.',
  'cat.edit.coverUrl': 'Cover image link',
  'cat.edit.create': 'Create record',
  'cat.edit.created': 'Record created',
  'cat.edit.defaultItemType': 'Default item type',
  'cat.edit.descriptionNew': 'Describe the title, then add its copies. Use ISBN lookup to start from existing data.',
  'cat.edit.dimensions': 'Dimensions',
  'cat.edit.edition': 'Edition',
  'cat.edit.extent': 'Extent',
  'cat.edit.fixErrors': '{n} problems to fix before saving',
  'cat.edit.genres': 'Genre or form',
  'cat.edit.isSerial': 'This is a serial',
  'cat.edit.isbnExisting': 'Records with this ISBN already exist',
  'cat.edit.isbnFetch': 'Look up',
  'cat.edit.isbnFilled': 'Filled {n} empty fields from the lookup.',
  'cat.edit.isbnInvalid': 'That is not a valid ISBN. Check the digits.',
  'cat.edit.isbnLookup': 'Start from an ISBN',
  'cat.edit.isbnLookupHint': 'Fills empty fields from public book data. Nothing you typed is overwritten.',
  'cat.edit.isbnMiss': 'No data found for that ISBN. Fill the form by hand.',
  'cat.edit.language': 'Language codes',
  'cat.edit.languageHint': 'Three-letter codes, comma separated',
  'cat.edit.mode': 'Editing mode',
  'cat.edit.modeMarc': 'MARC editor',
  'cat.edit.modeSimple': 'Simple form',
  'cat.edit.noChanges': 'No changes yet',
  'cat.edit.noCopies': 'No copies added',
  'cat.edit.noCopiesHint': 'You can also add copies later from the record page.',
  'cat.edit.notes': 'Notes',
  'cat.edit.otherAuthors': 'Other authors',
  'cat.edit.place': 'Place of publication',
  'cat.edit.publisher': 'Publisher',
  'cat.edit.removeCopyGroup': 'Remove copies group {n}',
  'cat.edit.removeRow': 'Remove {label}',
  'cat.edit.saved': 'Record saved',
  'cat.edit.sectionIdentifiers': 'Identifiers and classification',
  'cat.edit.sectionOptions': 'Record options',
  'cat.edit.sectionPublication': 'Publication',
  'cat.edit.sectionSubjects': 'Subjects and description',
  'cat.edit.sectionTitle': 'Title and author',
  'cat.edit.series': 'Series',
  'cat.edit.seriesNumber': 'Series number',
  'cat.edit.serverError': 'The record could not be saved',
  'cat.edit.simpleEditNote': 'The simple form rewrites the fields it shows. Use the MARC editor to keep other MARC fields exactly as they are.',
  'cat.edit.subjectsHint': 'Subjects link to authority records when you pick a suggestion.',
  'cat.edit.subtitle': 'Subtitle',
  'cat.edit.summary': 'Summary',
  'cat.edit.suppress': 'Hide from the public catalogue',
  'cat.edit.suppressHint': 'Staff can still find it',
  'cat.edit.titleEdit': 'Edit record',
  'cat.edit.titleNew': 'New bibliographic record',
  'cat.edit.unsaved': 'Unsaved changes',
  'cat.edit.year': 'Year',
  'cat.marc.addField': 'Add a field',
  'cat.marc.addFieldHint': 'Type a tag or name, for example 650 or subject',
  'cat.marc.addFieldPlaceholder': 'Search tags',
  'cat.marc.addMandatory': 'Add mandatory fields',
  'cat.marc.addSubfield': 'Add subfield',
  'cat.marc.customSubfield': 'Other code',
  'cat.marc.duplicate': 'Duplicate field {tag}',
  'cat.marc.framework': 'Framework',
  'cat.marc.indicator': 'Indicator {n}',
  'cat.marc.indicators': 'Indicators',
  'cat.marc.issues': '{n} validation messages',
  'cat.marc.leader': 'Leader',
  'cat.marc.leaderHint': '24 characters',
  'cat.marc.localField': 'Local field',
  'cat.marc.moveDown': 'Move field {tag} down',
  'cat.marc.moveUp': 'Move field {tag} up',
  'cat.marc.noTags': 'No matching tags',
  'cat.marc.removeField': 'Remove field {tag}',
  'cat.marc.removeSubfield': 'Remove {label}',
  'cat.marc.required': 'Required',
  'cat.marc.subfieldCode': 'Subfield code in {tag}',
} as const;

export const catEditorHi: Record<keyof typeof catEditorEn, string> = {
  'cat.dup.back': 'वापस जाएँ',
  'cat.dup.createAnyway': 'फिर भी बनाएँ',
  'cat.dup.description': 'इससे मिलते-जुलते रिकॉर्ड पहले से मौजूद हैं। नया जोड़ने से पहले उन्हें देख लें।',
  'cat.dup.title': 'संभावित डुप्लिकेट',
  'cat.dup.isbn': 'वही ISBN',
  'cat.dup.issn': 'वही ISSN',
  'cat.dup.titleAuthor': 'मिलता-जुलता शीर्षक और लेखक',
  'cat.edit.addAuthor': 'लेखक जोड़ें',
  'cat.edit.addCopies': 'प्रतियाँ जोड़ें',
  'cat.edit.addGenre': 'विधा जोड़ें',
  'cat.edit.addIsbn': 'ISBN जोड़ें',
  'cat.edit.addIssn': 'ISSN जोड़ें',
  'cat.edit.addSubject': 'विषय जोड़ें',
  'cat.edit.audience': 'पाठक वर्ग',
  'cat.edit.authorHint': 'उपनाम, नाम। सुझाव प्राधिकारी रिकॉर्ड से आते हैं।',
  'cat.edit.copies': 'प्रतियाँ',
  'cat.edit.copiesCount': 'प्रतियों की संख्या',
  'cat.edit.copiesHint': 'भौतिक प्रतियाँ अभी जोड़ें ताकि सहेजते ही शीर्षक उधार योग्य हो।',
  'cat.edit.copyGroup': 'प्रति समूह {n}',
  'cat.edit.coverHint': 'कवर चित्र का वैकल्पिक लिंक।',
  'cat.edit.coverUrl': 'कवर चित्र लिंक',
  'cat.edit.create': 'रिकॉर्ड बनाएँ',
  'cat.edit.created': 'रिकॉर्ड बनाया गया',
  'cat.edit.defaultItemType': 'डिफ़ॉल्ट आइटम प्रकार',
  'cat.edit.descriptionNew': 'शीर्षक का विवरण दें, फिर प्रतियाँ जोड़ें। मौजूदा डेटा से शुरू करने के लिए ISBN खोज उपयोग करें।',
  'cat.edit.dimensions': 'आयाम',
  'cat.edit.edition': 'संस्करण',
  'cat.edit.extent': 'विस्तार',
  'cat.edit.fixErrors': 'सहेजने से पहले {n} समस्याएँ ठीक करें',
  'cat.edit.genres': 'विधा या रूप',
  'cat.edit.isSerial': 'यह धारावाहिक है',
  'cat.edit.isbnExisting': 'इस ISBN वाले रिकॉर्ड पहले से मौजूद हैं',
  'cat.edit.isbnFetch': 'खोजें',
  'cat.edit.isbnFilled': 'खोज से {n} खाली फ़ील्ड भरे गए।',
  'cat.edit.isbnInvalid': 'यह मान्य ISBN नहीं है। अंक जाँचें।',
  'cat.edit.isbnLookup': 'ISBN से शुरू करें',
  'cat.edit.isbnLookupHint': 'सार्वजनिक पुस्तक डेटा से खाली फ़ील्ड भरता है। आपका लिखा कुछ नहीं बदलता।',
  'cat.edit.isbnMiss': 'इस ISBN का डेटा नहीं मिला। फ़ॉर्म हाथ से भरें।',
  'cat.edit.language': 'भाषा कोड',
  'cat.edit.languageHint': 'तीन अक्षर के कोड, अल्पविराम से अलग',
  'cat.edit.mode': 'संपादन मोड',
  'cat.edit.modeMarc': 'MARC संपादक',
  'cat.edit.modeSimple': 'सरल फ़ॉर्म',
  'cat.edit.noChanges': 'अभी कोई बदलाव नहीं',
  'cat.edit.noCopies': 'कोई प्रति नहीं जोड़ी गई',
  'cat.edit.noCopiesHint': 'आप बाद में रिकॉर्ड पृष्ठ से भी प्रतियाँ जोड़ सकते हैं।',
  'cat.edit.notes': 'टिप्पणियाँ',
  'cat.edit.otherAuthors': 'अन्य लेखक',
  'cat.edit.place': 'प्रकाशन स्थान',
  'cat.edit.publisher': 'प्रकाशक',
  'cat.edit.removeCopyGroup': 'प्रति समूह {n} हटाएँ',
  'cat.edit.removeRow': '{label} हटाएँ',
  'cat.edit.saved': 'रिकॉर्ड सहेजा गया',
  'cat.edit.sectionIdentifiers': 'पहचानकर्ता और वर्गीकरण',
  'cat.edit.sectionOptions': 'रिकॉर्ड विकल्प',
  'cat.edit.sectionPublication': 'प्रकाशन',
  'cat.edit.sectionSubjects': 'विषय और विवरण',
  'cat.edit.sectionTitle': 'शीर्षक और लेखक',
  'cat.edit.series': 'श्रृंखला',
  'cat.edit.seriesNumber': 'श्रृंखला संख्या',
  'cat.edit.serverError': 'रिकॉर्ड सहेजा नहीं जा सका',
  'cat.edit.simpleEditNote': 'सरल फ़ॉर्म अपने दिखाए फ़ील्ड फिर से लिखता है। अन्य MARC फ़ील्ड जस के तस रखने के लिए MARC संपादक उपयोग करें।',
  'cat.edit.subjectsHint': 'सुझाव चुनने पर विषय प्राधिकारी रिकॉर्ड से जुड़ जाते हैं।',
  'cat.edit.subtitle': 'उप-शीर्षक',
  'cat.edit.summary': 'सारांश',
  'cat.edit.suppress': 'सार्वजनिक सूची से छिपाएँ',
  'cat.edit.suppressHint': 'स्टाफ़ इसे फिर भी खोज सकता है',
  'cat.edit.titleEdit': 'रिकॉर्ड संपादित करें',
  'cat.edit.titleNew': 'नया ग्रंथ-सूची रिकॉर्ड',
  'cat.edit.unsaved': 'बिना सहेजे बदलाव',
  'cat.edit.year': 'वर्ष',
  'cat.marc.addField': 'फ़ील्ड जोड़ें',
  'cat.marc.addFieldHint': 'टैग या नाम लिखें, जैसे 650 या subject',
  'cat.marc.addFieldPlaceholder': 'टैग खोजें',
  'cat.marc.addMandatory': 'अनिवार्य फ़ील्ड जोड़ें',
  'cat.marc.addSubfield': 'उप-फ़ील्ड जोड़ें',
  'cat.marc.customSubfield': 'अन्य कोड',
  'cat.marc.duplicate': 'फ़ील्ड {tag} की प्रति बनाएँ',
  'cat.marc.framework': 'फ़्रेमवर्क',
  'cat.marc.indicator': 'संकेतक {n}',
  'cat.marc.indicators': 'संकेतक',
  'cat.marc.issues': '{n} सत्यापन संदेश',
  'cat.marc.leader': 'लीडर',
  'cat.marc.leaderHint': '24 अक्षर',
  'cat.marc.localField': 'स्थानीय फ़ील्ड',
  'cat.marc.moveDown': 'फ़ील्ड {tag} नीचे ले जाएँ',
  'cat.marc.moveUp': 'फ़ील्ड {tag} ऊपर ले जाएँ',
  'cat.marc.noTags': 'कोई मेल खाता टैग नहीं',
  'cat.marc.removeField': 'फ़ील्ड {tag} हटाएँ',
  'cat.marc.removeSubfield': '{label} हटाएँ',
  'cat.marc.required': 'अनिवार्य',
  'cat.marc.subfieldCode': '{tag} में उप-फ़ील्ड कोड',
};
